"use strict";

const baseTemplate = document.createElement("template");
baseTemplate.innerHTML = require("./template");


class Input extends HTMLElement {
    constructor(template) {
        super(template);

        this.root = this.attachShadow({ mode: "open" });

        const content = template ? template.content.cloneNode(true) : baseTemplate.content.cloneNode(true);
        this.root.appendChild(content);
        this.inputElement = this.root.querySelector('input[type="checkbox"]');
        this.labelElement = this.root.querySelector("label");
        this.messageElement = this.root.querySelector("swiftref-message");

        this.initSlots();

        this.inputElement.addEventListener("change", function (event) {
            /**
             * 'this' is the component <swiftref-checkbox></swiftref-checkbox>,
             * forward the checked attribute from the input to the component
             */
            this.checked = this.inputElement.checked;
            this.dispatchEvent(new CustomEvent("change", {
                detail: {
                    value: this.inputElement.value
                },
                bubbles: true
                // composed: true
            }))
        }.bind(this));




    }

    static get observedAttributes() {
        return [
            "message",
            "value",
            "label",
            "checked",
            "disabled",
            "indeterminate",
            "name"
        ];
    }

    get message() {
        return this.getAttribute("message");
    }
    set message(message) {
        this.setAttribute("message", message);
    }
    get value() {
        return this.inputElement.value.trim();
    }
    set value(value) {
        this.setAttribute("value", value);
    }
    get checked() {
        return this.hasAttribute("checked");
    }
    set checked(value) {
        if (value) {
            this.setAttribute("checked", value);
        } else {
            this.removeAttribute("checked");
        }
    }
    get disabled() {
        return this.hasAttribute("disabled");
    }
    set disabled(value) {
        if (value) {
            this.setAttribute("disabled", value);
        } else {
            this.removeAttribute("disabled");
        }
    }
    get indeterminate() {
        return this.hasAttribute("indeterminate");
    }
    set indeterminate(value) {
        if (value) {
            this.setAttribute("indeterminate", value);
        } else {
            this.removeAttribute("indeterminate");
        }
    }
    get label() {
        return this.getAttribute("label");
    }
    set label(value) {
        this.setAttribute("label", value);
    }
    get name() {
        return this.getAttribute("name");
    }
    set name(value) {
        this.setAttribute("name", value);
    }

    initSlots () {
        if (this.innerHTML) {

        }
    }


    renderAttribute (name, value) {
        switch (name) {
            case "checked":
            case "disabled":
            case "indeterminate":
                this.inputElement[name] = this[name];
                break;
            case "value":
                this.inputElement.value = value;
                break;
            case "label": {
                const checkbox = this.inputElement;
                this.labelElement.textContent = value;
                this.labelElement.prepend(checkbox);
                this.inputElement = checkbox;
                break;
            }
            case "message":
                if (value) {
                    this.messageElement.setAttribute("message", value);
                } else {
                    this.messageElement.removeAttribute("message");
                }
                break;
            default:
                break;
        }
    }


    attributeChangedCallback(name, oldVal, newVal) {
        this.renderAttribute(name, newVal);
    }




}

window.customElements.define("swiftref-checkbox", Input);

module.exports = Input;
